import ManagerFlightBookingDetail from './ManagerFlightBookingDetail';

export default ManagerFlightBookingDetail;
